import React from "react";
import { Link } from "react-router-dom";

import landscapeImage from "../assets/images/landscape-design.jpg";

const LandscapeDesign = () => {
  const services = [
    {
      title: "Garden Design",
      description:
        "Customized garden designs planned around your property, lifestyle, available space, and preferred planting style. We create balanced and attractive gardens that are practical, inviting, and easy to maintain.",
    },
    {
      title: "Villa Landscape Design",
      description:
        "Complete landscape concepts for villas including gardens, lawns, planting areas, pathways, seating spaces, and decorative landscape elements designed to complement the property.",
    },
    {
      title: "Residential Landscape Design",
      description:
        "Professional outdoor landscape planning for homes and residential properties, creating comfortable and attractive spaces for relaxation, family activities, and everyday outdoor living.",
    },
    {
      title: "Soft Landscaping",
      description:
        "Professional planting solutions using suitable trees, shrubs, flowers, ground covers, lawns, and other greenery selected according to the environment and landscape requirements.",
    },
    {
      title: "Hard Landscaping",
      description:
        "Thoughtfully planned hardscape elements including pathways, paving, walls, seating areas, edging, outdoor structures, and other features that improve the functionality of your landscape.",
    },
    {
      title: "Outdoor Landscape Design",
      description:
        "Functional and visually appealing outdoor environments designed around your requirements, combining greenery, hardscape, lighting, seating, and other landscape features.",
    },
    {
      title: "Modern Landscape Design",
      description:
        "Contemporary landscape concepts featuring clean lines, organized layouts, modern planting, outdoor living areas, and stylish design elements for a sophisticated appearance.",
    },
    {
      title: "Luxury Landscape Design",
      description:
        "Premium landscape concepts for villas and high-end properties with carefully planned greenery, water features, outdoor entertainment areas, lighting, and architectural landscape elements.",
    },
    {
      title: "Garden Landscaping",
      description:
        "Complete garden landscaping solutions that bring together plants, lawns, pathways, decorative elements, seating areas, and other features to create a cohesive outdoor environment.",
    },
  ];

  const features = [
    {
      title: "Customized Designs",
      description:
        "Every landscape concept is planned according to the property, available space, architectural style, and individual requirements.",
    },
    {
      title: "Climate-Suitable Planting",
      description:
        "We consider the local environment and select suitable greenery and planting concepts for long-term landscape performance.",
    },
    {
      title: "Functional Outdoor Spaces",
      description:
        "Our designs focus not only on appearance but also on creating outdoor areas that are comfortable and practical to use.",
    },
    {
      title: "Complete Landscape Planning",
      description:
        "From planting and lawns to pathways, seating, lighting, and decorative elements, we plan the landscape as a complete environment.",
    },
    {
      title: "Modern & Creative Concepts",
      description:
        "We combine modern design ideas with practical landscaping principles to create attractive and distinctive outdoor spaces.",
    },
    {
      title: "Long-Term Design Approach",
      description:
        "Our landscape planning considers maintenance, plant growth, usability, and the long-term appearance of the outdoor space.",
    },
  ];

  const process = [
    {
      number: "01",
      title: "Initial Consultation",
      description:
        "We understand your requirements, preferences, property style, budget considerations, and expectations for the landscape.",
    },
    {
      number: "02",
      title: "Site Assessment",
      description:
        "We evaluate the available space, existing landscape, property layout, sunlight, access, and other important site conditions.",
    },
    {
      number: "03",
      title: "Landscape Planning",
      description:
        "Our team develops the overall landscape concept, including planting areas, lawns, pathways, seating, and other outdoor features.",
    },
    {
      number: "04",
      title: "Design Development",
      description:
        "The landscape design is refined with suitable materials, plants, layouts, decorative features, and functional outdoor elements.",
    },
    {
      number: "05",
      title: "Final Design",
      description:
        "The final landscape concept is prepared according to the approved requirements and planned for practical implementation.",
    },
  ];

  const faqs = [
    {
      question: "What does landscape design include?",
      answer:
        "Landscape design can include garden planning, planting, lawns, pathways, outdoor seating, hard landscaping, lighting concepts, water features, and other outdoor elements depending on the project.",
    },
    {
      question: "Do you provide landscape design for villas in Dubai?",
      answer:
        "Yes. We create customized villa landscape designs for different property sizes and styles, including gardens, lawns, planting, pathways, seating areas, and other outdoor features.",
    },
    {
      question: "Can you design a modern garden?",
      answer:
        "Yes. We can create modern garden and landscape concepts using clean layouts, contemporary planting, outdoor living areas, and modern landscape features.",
    },
    {
      question: "Do you design small outdoor spaces?",
      answer:
        "Yes. Landscape design can be adapted to small gardens, terraces, courtyards, villa entrances, and other compact outdoor spaces.",
    },
    {
      question: "Can swimming pools be included in landscape design?",
      answer:
        "Yes. Swimming pools can be integrated into the overall landscape concept along with pool decking, planting, pathways, lighting, seating, and surrounding outdoor areas.",
    },
    {
      question: "How do you choose plants for a landscape?",
      answer:
        "Plant selection depends on the property's conditions, available space, design requirements, maintenance expectations, and suitability for the local environment.",
    },
  ];

  return (
    <>
      {/* =========================
          HERO
      ========================= */}

      <section
        className="service-detail-hero"
        style={{
          backgroundImage: `url(${landscapeImage})`,
        }}
      >
        <div className="service-detail-overlay">
          <div className="container text-center">
            <h1>Landscape Design in Dubai</h1>

            <p>
              Creative and professional landscape design solutions for
              beautiful, functional, and sustainable outdoor spaces.
            </p>

            <Link to="/contact" className="service-detail-hero-btn">
              GET A QUOTE
            </Link>
          </div>
        </div>
      </section>

      {/* =========================
          INTRODUCTION
      ========================= */}

      <section className="service-detail-content">
        <div className="container">
          <div className="service-detail-heading">
            <span>LANDSCAPE DESIGN</span>

            <h2>
              Beautiful Landscape Design Tailored to Your Space
            </h2>

            <p>
              We create thoughtfully designed outdoor spaces that combine
              beauty, functionality, comfort, and long-term sustainability.
              Our landscape design solutions are planned around your property,
              lifestyle, architecture, available space, and individual
              requirements.
            </p>

            <p>
              From private villa gardens and residential landscapes to modern
              outdoor spaces and luxury garden environments, we develop
              landscape concepts that transform ordinary outdoor areas into
              attractive and enjoyable spaces.
            </p>

            <p>
              Our approach brings together planting, lawns, pathways,
              hardscaping, outdoor seating, lighting, water features, and other
              landscape elements to create a complete and well-balanced
              environment.
            </p>
          </div>

          {/* =========================
              SERVICES
          ========================= */}

          <div className="service-subcategories">
  <div className="section-title" style={{margin:"20px auto" , width:"100%", maxWidth:"100%"}}>
              <span>OUR SERVICES</span>

              <h3>Complete Landscape Design Services</h3>

              <p>
                Explore our professional landscape design solutions for villas,
                homes, gardens, and outdoor spaces across Dubai.
              </p>
            </div>

            <div className="row">
              {services.map((service, index) => (
                <div
                  className="col-lg-4 col-md-6 col-12"
                  key={index}
                >
                  <div className="subcategory-card">
                    <div className="subcategory-number">
                      {String(index + 1).padStart(2, "0")}
                    </div>

                    <h4>{service.title}</h4>

                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* =========================
              WHY US
          ========================= */}

          <div className="landscape-features-section">
  <div className="section-title" style={{margin:"20px auto" , width:"100%", maxWidth:"100%"}}>
              <span>WHY CHOOSE US</span>

              <h3>Landscape Designs Planned Around Your Needs</h3>

              <p>
                We focus on creating outdoor environments that look beautiful,
                work naturally with the property, and remain practical for
                everyday use.
              </p>
            </div>

            <div className="row">
              {features.map((feature, index) => (
                <div
                  className="col-lg-4 col-md-6 col-12"
                  key={index}
                >
                  <div className="landscape-feature-card">
                    <div className="feature-icon">
                      <i className="fas fa-leaf"></i>
                    </div>

                    <h4>{feature.title}</h4>

                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* =========================
              PROCESS
          ========================= */}

          <div className="landscape-process-section">
  <div className="section-title" style={{margin:"20px auto" , width:"100%", maxWidth:"100%"}}>
              <span>OUR PROCESS</span>

              <h3>Our Landscape Design Process</h3>

              <p>
                From the first consultation to the final concept, we follow a
                structured process to develop a landscape design that fits
                your property.
              </p>
            </div>

            <div className="row">
              {process.map((step, index) => (
                <div
                  className="col-lg-4 col-md-6 col-12"
                  key={index}
                >
                  <div className="process-card">
                    <div className="process-number">
                      {step.number}
                    </div>

                    <h4>{step.title}</h4>

                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* =========================
              LANDSCAPE ELEMENTS
          ========================= */}

          <div className="landscape-elements-section">
  <div className="section-title" style={{margin:"20px auto" , width:"100%", maxWidth:"100%"}}>
              <span>LANDSCAPE ELEMENTS</span>

              <h3>Everything Your Outdoor Space Needs</h3>

              <p>
                A successful landscape design brings different outdoor
                elements together into one cohesive and functional environment.
              </p>
            </div>

            <div className="landscape-elements-grid">
              <div className="landscape-element">
                <i className="fas fa-tree"></i>
                <h4>Trees & Plants</h4>
              </div>

              <div className="landscape-element">
                <i className="fas fa-seedling"></i>
                <h4>Garden Areas</h4>
              </div>

              <div className="landscape-element">
                <i className="fas fa-grip-horizontal"></i>
                <h4>Lawns</h4>
              </div>

              <div className="landscape-element">
                <i className="fas fa-road"></i>
                <h4>Pathways</h4>
              </div>

              <div className="landscape-element">
                <i className="fas fa-chair"></i>
                <h4>Outdoor Seating</h4>
              </div>

              <div className="landscape-element">
                <i className="fas fa-lightbulb"></i>
                <h4>Landscape Lighting</h4>
              </div>

              <div className="landscape-element">
                <i className="fas fa-water"></i>
                <h4>Water Features</h4>
              </div>

              <div className="landscape-element">
                <i className="fas fa-border-all"></i>
                <h4>Hard Landscaping</h4>
              </div>
            </div>
          </div>

          {/* =========================
              FAQ
          ========================= */}

          <div className="landscape-faq-section">
  <div className="section-title" style={{margin:"20px auto" , width:"100%", maxWidth:"100%"}}>
              <span>FAQ</span>

              <h3>Frequently Asked Questions</h3>

              <p>
                Find answers to common questions about landscape design and
                outdoor landscaping.
              </p>
            </div>

            <div className="faq-wrapper">
              {faqs.map((faq, index) => (
                <div className="faq-item" key={index}>
                  <h4>{faq.question}</h4>

                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>

          {/* =========================
              CTA
          ========================= */}

          
        </div>
      </section>

















{/* =========================
    OUR LANDSCAPE PROJECTS
========================= */}
<div className="container">
<div className="landscape-projects-section">

  <div className="section-title" style={{margin:"20px auto" , width:"100%", maxWidth:"100%"}}>
<center>
    <span >OUR PROJECTS</span>

    <h3>
      Our Landscape Design Projects
    </h3>

    <p>
      Explore our landscape design projects across Dubai and the UAE,
      including luxury villas, resorts, hotels, communities, and
      large-scale outdoor spaces.
    </p>

</center>
  
  </div>


  <div className="row">

    {/* Jumeirah Golf Estate */}

    <div className="col-lg-4 col-md-6 col-12">
      <div className="landscape-project-card">

        <div className="landscape-project-image">
          <img
            src={require("../assets/images/jumeirah golf estate 6.jpg")}
            alt="Jumeirah Golf Estate Landscape Design"
          />
        </div>

        <div className="landscape-project-content">
          <span>LANDSCAPE DESIGN</span>

          <h4>
            Jumeirah Golf Estate
          </h4>

          <p>
            Professional landscape design and outdoor planning for
            Jumeirah Golf Estate, Dubai.
          </p>
        </div>

      </div>
    </div>


    {/* Lafarge Holcim */}

    <div className="col-lg-4 col-md-6 col-12">
      <div className="landscape-project-card">

        <div className="landscape-project-image">
          <img
            src={require("../assets/images/Lafarge Holcim 2.jfif")}
            alt="Lafarge Holcim Landscape Design"
          />
        </div>

        <div className="landscape-project-content">
          <span>LANDSCAPE PROJECT</span>

          <h4>
            Lafarge Holcim
          </h4>

          <p>
            Landscape design and outdoor environment planning created
            for the Lafarge Holcim project.
          </p>
        </div>

      </div>
    </div>


    {/* Masaar Sharjah */}

    <div className="col-lg-4 col-md-6 col-12">
      <div className="landscape-project-card">

        <div className="landscape-project-image">
          <img
            src={require("../assets/images/masaar sharjah 2.jpeg")}
            alt="Masaar Sharjah Landscape Design"
          />
        </div>

        <div className="landscape-project-content">
          <span>LANDSCAPE DESIGN</span>

          <h4>
            Masaar Sharjah
          </h4>

          <p>
            Landscape and outdoor design solutions developed for
            Masaar, Sharjah.
          </p>
        </div>

      </div>
    </div>


    {/* Meydan Dubai */}

    <div className="col-lg-4 col-md-6 col-12">
      <div className="landscape-project-card">

        <div className="landscape-project-image">
          <img
            src={require("../assets/images/Meydan dubai 3.jpg")}
            alt="Meydan Dubai Landscape Design"
          />
        </div>

        <div className="landscape-project-content">
          <span>LANDSCAPE DESIGN</span>

          <h4>
            Meydan Dubai
          </h4>

          <p>
            Professional landscape design solutions for outdoor spaces
            in Meydan, Dubai.
          </p>
        </div>

      </div>
    </div>


    {/* Paramount Hotel */}

    <div className="col-lg-4 col-md-6 col-12">
      <div className="landscape-project-card">

        <div className="landscape-project-image">
          <img
            src={require("../assets/images/Paramount hotel5.jfif")}
            alt="Paramount Hotel Landscape Design Dubai"
          />
        </div>

        <div className="landscape-project-content">
          <span>HOTEL LANDSCAPE</span>

          <h4>
            Paramount Hotel
          </h4>

          <p>
            Landscape design and outdoor environment solutions for
            Paramount Hotel, Dubai.
          </p>
        </div>

      </div>
    </div>


    {/* Pulse Beach */}

    <div className="col-lg-4 col-md-6 col-12">
      <div className="landscape-project-card">

        <div className="landscape-project-image">
          <img
            src={require("../assets/images/Pulse beach 2.jpeg")}
            alt="Pulse Beach Landscape Design Dubai"
          />
        </div>

        <div className="landscape-project-content">
          <span>BEACH LANDSCAPE</span>

          <h4>
            Pulse Beach
          </h4>

          <p>
            Creative landscape design and outdoor planning for the
            Pulse Beach project.
          </p>
        </div>

      </div>
    </div>


    {/* Villa Tilal Ghaf */}

    <div className="col-lg-4 col-md-6 col-12">
      <div className="landscape-project-card">

        <div className="landscape-project-image">
          <img
            src={require("../assets/images/villa-tilal-ghaf.jpeg")}
            alt="Villa Tilal Ghaf Landscape Design Dubai"
          />
        </div>

        <div className="landscape-project-content">
          <span>VILLA LANDSCAPE</span>

          <h4>
            Villa Tilal Ghaf
          </h4>

          <p>
            Customized villa landscape design created for an elegant
            outdoor environment at Tilal Ghaf, Dubai.
          </p>
        </div>

      </div>
    </div>

  </div>

</div>
</div>

<div className="service-detail-cta">
            <h3>
              Ready to Transform Your Outdoor Space?
            </h3>

            <p>
              Talk to our landscaping experts about your project and create a
              beautiful outdoor environment designed around your needs.
            </p>

            <Link
              to="/contact"
              className="service-detail-btn"
            >
              GET A QUOTE
            </Link>
          </div>


<br/>
      <style>
        {`

.landscape-projects-section {
  margin-bottom: 90px;
}

.landscape-projects-section .row {
  row-gap: 30px;
}

.landscape-project-card {
  height: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eee;
  transition: .3s;
}

.landscape-project-card:hover {
  transform: translateY(-7px);
  box-shadow: 0 15px 35px rgba(0,0,0,.10);
}

.landscape-project-image {
  width: 100%;
  height: 270px;
  overflow: hidden;
}

.landscape-project-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: .4s;
}

.landscape-project-card:hover
.landscape-project-image img {
  transform: scale(1.06);
}

.landscape-project-content {
  padding: 25px;
}

.landscape-project-content span {
  display: block;
  margin-bottom: 8px;
  color: #4c8b3c;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
}

.landscape-project-content h4 {
  margin-bottom: 10px;
  font-size: 21px;
  font-weight: 700;
}

.landscape-project-content p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.75;
}

@media(max-width:767px) {

  .landscape-projects-section {
    margin-bottom: 60px;
  }

  .landscape-project-image {
    height: 230px;
  }

  .landscape-project-content {
    padding: 22px;
  }

}
        .service-detail-hero {
          min-height: 550px;
          background-size: cover;
          background-position: center;
          position: relative;
          display: flex;
          align-items: center;
        }

        .service-detail-overlay {
          width: 100%;
          padding: 100px 20px;
          background: rgba(0, 0, 0, .48);
        }

        .service-detail-hero h1 {
          color: #fff;
          font-size: 55px;
          font-weight: 700;
          margin-bottom: 15px;
        }

        .service-detail-hero p {
          max-width: 750px;
          margin: auto auto 25px;
          color: #fff;
          font-size: 18px;
          line-height: 1.7;
        }

        .service-detail-hero-btn {
          display: inline-block;
          padding: 13px 28px;
          color: #4c8b3c;
          background: #fff;
          border-radius: 4px;
          font-size: 13px;
          font-weight: 700;
          text-decoration: none;
          transition: .3s;
        }

        .service-detail-hero-btn:hover {
          color: #fff;
          background: #4c8b3c;
          text-decoration: none;
        }


        .service-detail-content {
          padding: 90px 20px;
        }

        .service-detail-heading {
          max-width: 900px;
          margin: 0 auto 80px;
          text-align: center;
        }

        .service-detail-heading span,
        .section-title span {
          color: #4c8b3c;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 3px;
        }

        .service-detail-heading h2 {
          margin: 12px 0 20px;
          font-size: 40px;
          font-weight: 700;
          line-height: 1.3;
        }

        .service-detail-heading p {
          margin-bottom: 15px;
          color: #666;
          font-size: 16px;
          line-height: 1.85;
        }


        .section-title {
          max-width: 850px;
          margin: 0 auto 45px;
          text-align: center;
        }

        .section-title h3 {
          margin: 10px 0 15px;
          font-size: 34px;
          font-weight: 700;
        }

        .section-title p {
          margin: 0;
          color: #666;
          line-height: 1.8;
        }


        .service-subcategories {
          margin-bottom: 90px;
        }

        .subcategory-card {
          height: calc(100% - 30px);
          margin-bottom: 30px;
          padding: 32px;
          background: #f7faf6;
          border-radius: 10px;
          border-left: 4px solid #4c8b3c;
          transition: .3s;
        }

        .subcategory-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 30px rgba(0,0,0,.08);
        }

        .subcategory-number {
          margin-bottom: 15px;
          color: #4c8b3c;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: 2px;
        }

        .subcategory-card h4 {
          margin-bottom: 12px;
          font-size: 21px;
          font-weight: 700;
        }

        .subcategory-card p {
          margin: 0;
          color: #666;
          font-size: 14px;
          line-height: 1.75;
        }


        .landscape-features-section {
          margin-bottom: 90px;
          padding: 75px 0;
          background: #f8faf7;
        }

        .landscape-feature-card {
          height: calc(100% - 30px);
          margin-bottom: 30px;
          padding: 30px;
          background: #fff;
          border-radius: 10px;
          transition: .3s;
        }

        .landscape-feature-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,.08);
        }

        .feature-icon {
          width: 55px;
          height: 55px;
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #edf6ea;
          border-radius: 50%;
        }

        .feature-icon i {
          color: #4c8b3c;
          font-size: 23px;
        }

        .landscape-feature-card h4 {
          margin-bottom: 10px;
          font-size: 20px;
          font-weight: 700;
        }

        .landscape-feature-card p {
          margin: 0;
          color: #666;
          line-height: 1.7;
        }


        .landscape-process-section {
          margin-bottom: 90px;
        }

        .process-card {
          height: calc(100% - 30px);
          margin-bottom: 30px;
          padding: 30px;
          background: #fff;
          border: 1px solid #eee;
          border-radius: 10px;
          transition: .3s;
        }

        .process-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,.07);
        }

        .process-number {
          margin-bottom: 18px;
          color: #4c8b3c;
          font-size: 36px;
          font-weight: 800;
        }

        .process-card h4 {
          margin-bottom: 10px;
          font-size: 20px;
          font-weight: 700;
        }

        .process-card p {
          margin: 0;
          color: #666;
          line-height: 1.7;
        }


        .landscape-elements-section {
          margin-bottom: 90px;
        }

        .landscape-elements-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }

        .landscape-element {
          padding: 30px 20px;
          text-align: center;
          background: #f7faf6;
          border-radius: 10px;
          transition: .3s;
        }

        .landscape-element:hover {
          transform: translateY(-5px);
          background: #edf6ea;
        }

        .landscape-element i {
          margin-bottom: 15px;
          color: #4c8b3c;
          font-size: 30px;
        }

        .landscape-element h4 {
          margin: 0;
          font-size: 17px;
          font-weight: 700;
        }


        .landscape-faq-section {
          max-width: 950px;
          margin: 0 auto 70px;
        }

        .faq-wrapper {
          border-top: 1px solid #ddd;
        }

        .faq-item {
          padding: 25px 0;
          border-bottom: 1px solid #ddd;
        }

        .faq-item h4 {
          margin-bottom: 10px;
          font-size: 19px;
          font-weight: 700;
        }

        .faq-item p {
          margin: 0;
          color: #666;
          line-height: 1.75;
        }


        .service-detail-cta {
          margin-top: 50px;
          padding: 60px 30px;
          text-align: center;
          border-radius: 12px;
          background: #4c8b3c;
        }

        .service-detail-cta h3 {
          color: #fff;
          font-size: 32px;
          font-weight: 700;
        }

        .service-detail-cta p {
          max-width: 700px;
          margin: 12px auto;
          color: #fff;
          line-height: 1.7;
        }

        .service-detail-btn {
          display: inline-block;
          margin-top: 15px;
          padding: 13px 28px;
          color: #4c8b3c;
          background: #fff;
          border-radius: 4px;
          font-weight: 700;
          text-decoration: none;
          transition: .3s;
        }

        .service-detail-btn:hover {
          color: #4c8b3c;
          background: #f2f2f2;
          text-decoration: none;
        }


        @media(max-width: 991px) {

          .landscape-elements-grid {
            grid-template-columns: repeat(2, 1fr);
          }

        }


        @media(max-width: 767px) {

          .service-detail-hero {
            min-height: 430px;
          }

          .service-detail-overlay {
            padding: 80px 15px;
          }

          .service-detail-hero h1 {
            font-size: 35px;
          }

          .service-detail-hero p {
            font-size: 15px;
          }

          .service-detail-content {
            padding: 60px 15px;
          }

          .service-detail-heading {
            margin-bottom: 60px;
          }

          .service-detail-heading h2 {
            font-size: 30px;
          }

          .section-title h3 {
            font-size: 28px;
          }

          .landscape-features-section {
            padding: 50px 15px;
          }

          .landscape-elements-grid {
            grid-template-columns: 1fr;
          }

          .service-detail-cta {
            padding: 45px 20px;
          }

          .service-detail-cta h3 {
            font-size: 27px;
          }

        }

        `}
      </style>
    </>
  );
};

export default LandscapeDesign;
